import Types from "./types";

export default class Dispatcher {
    constructor(dispatch) {
        this.dispatch = dispatch;
    }

    fetchStart = payload => this.dispatch({ type: Types.FETCH_START, payload });

    changeDate = payload => this.dispatch({ type: Types.CHANGE_DATE, payload });

    changeDateType = (payload) => this.dispatch({type : Types.CHANGE_DATE_TYPE, payload});

    resetError = () => this.dispatch({ type: Types.RESET_ERROR, payload: {} });
}